import { HStack, VStack } from '@genial/components';
import { BoxRadius, Color, Spacing, Typography } from '@genial/design-tokens';
import { Skeleton } from 'native-base';
import React from 'react';

import { TableContent } from '../../../../../../components/TableContent';

interface SkeletonItemMobileProps {}

export const SkeletonTagsMobile: React.FC<SkeletonItemMobileProps> = () => {
  return (
    <TableContent direction="column" space={Spacing['inline.xxxs']} p={0}>
      <VStack space={Spacing['stack.nano']} w="full">
        <HStack space={Spacing['stack.quarck']} flex={1}>
          <Skeleton
            w="full"
            h={Typography['fontsize.xxl']}
            borderRadius={BoxRadius.sm}
            endColor={Color['brand.primary.lightest']}
          />
        </HStack>
      </VStack>
      <HStack
        space={Spacing['stack.nano']}
        flexDirection={'row'}
        alignItems="center"
        w="full"
        flexWrap={'wrap'}>
        {/* <VStack space={Spacing['stack.nano']} flex={1}> */}
        <Skeleton
          w="16%"
          h={Typography['fontsize.xl']}
          borderRadius={BoxRadius.sm}
          endColor={Color['brand.primary.lightest']}
          mb={Spacing['stack.xxxs']}
        />
        <Skeleton
          w="16%"
          h={Typography['fontsize.xl']}
          borderRadius={BoxRadius.sm}
          endColor={Color['brand.primary.lightest']}
          mb={Spacing['stack.xxxs']}
        />
        <Skeleton
          w="16%"
          h={Typography['fontsize.xl']}
          borderRadius={BoxRadius.sm}
          endColor={Color['brand.primary.lightest']}
          mb={Spacing['stack.xxxs']}
        />
        <Skeleton
          w="16%"
          h={Typography['fontsize.xl']}
          borderRadius={BoxRadius.sm}
          endColor={Color['brand.primary.lightest']}
          mb={Spacing['stack.xxxs']}
        />
        <Skeleton
          w="16%"
          h={Typography['fontsize.xl']}
          borderRadius={BoxRadius.sm}
          endColor={Color['brand.primary.lightest']}
          mb={Spacing['stack.xxxs']}
        />
        <Skeleton
          w="16%"
          h={Typography['fontsize.xl']}
          borderRadius={BoxRadius.sm}
          endColor={Color['brand.primary.lightest']}
          mb={Spacing['stack.xxxs']}
        />
        <Skeleton
          w="16%"
          h={Typography['fontsize.xl']}
          borderRadius={BoxRadius.sm}
          endColor={Color['brand.primary.lightest']}
          mb={Spacing['stack.xxxs']}
        />
        {/* </VStack> */}
      </HStack>
    </TableContent>
  );
};
